import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "b1c81tSx+VJLIzdqqwfUN2j", "BgRoot", undefined);

import { _decorator, Component, Node, Camera } from 'cc';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var BgRoot = (_dec = ccclass('BgRoot'), _dec2 = property(Camera), _dec3 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BgRoot, _Component);

  function BgRoot() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "cam_bg", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_bg", _descriptor2, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = BgRoot.prototype;

  // [1]
  // dummy = '';
  // [2]
  // @property
  // serializableDummy = 0;
  _proto.onLoad = function onLoad() {
    App.GameCtrl.cam_bg = this.cam_bg;
    App.GameCtrl.n_bg = this.n_bg;
  };

  _proto.start = function start() {// [3]
  };

  _proto.update = function update(deltaTime) {// let posW_game: Vec3 = App.GameCtrl.cam_game.node.worldPosition;
    // let x: number = posW_game.x;
    // let z: number = posW_game.z;
    // let y: number = (App.DataMgr.vSize_game.height - App.DataMgr.vBaseSize_game.height) / 2;
    // App.GameCtrl.cam_bg.node.setWorldPosition(v3(x, y, z));
    // this.n_bg.worldPosition = v3(x ,this.n_bg.worldPosition.y, this.n_bg.worldPosition.z);
  };

  return BgRoot;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "cam_bg", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "n_bg", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();